import {AfterViewInit, Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {combineLatest, debounceTime, filter, Observable, startWith, Subscription, switchMap, take} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NotificationService} from '../../_services/notification.service';
import {Notification} from '../../_types/notification';
import {Community} from '../../_types/communities';
import {NotificationsListComponent} from "../notifications-list/notifications-list.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {SocketService} from "../../_services/socket.service";
import {CommunitiesService} from "../../_services/communities.service";

@Component({
    selector: 'app-header-notifications',
    templateUrl: './header-notifications.component.html',
    styleUrl: './header-notifications.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderNotificationsComponent implements AfterViewInit, OnDestroy {
    notifications: Notification[] = [];
    newNotifications: number = 0;
    isBellRinging: boolean = false;
    private subscription?: Subscription;

    constructor(
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly communitiesService: CommunitiesService,
        public dialog: MatDialog,
        private socketService: SocketService,
    ) {
        const community$: Observable<Community | null> = this.communitiesService.getCurrentDashboardCommunity().pipe(
            startWith(null as Community | null)
        );
        const router$: Observable<NavigationEnd> = this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            startWith(new NavigationEnd(0, this.router.url, this.router.url)),
        );
        combineLatest([community$, router$])
            .pipe(
                debounceTime(200),
                switchMap((): Observable<Notification[]> => this.notificationService.getNotifications(true)),
                takeUntilDestroyed()
            )
            .subscribe(res => {
                this.notifications = res;
                this.newNotifications = this.notifications.length;
            });
    }


    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.subscription = this.socketService.getNewNotification().subscribe(data => {
            if (data) {
                this.isBellRinging = true;
                setTimeout((): void => {
                    this.isBellRinging = false;
                }, 2000);
                this.notificationService.getNotifications(true).subscribe(res => {
                    this.notifications = res;
                    this.newNotifications = this.notifications.length;
                });
            }
        });
    }

    clearNotifications(): void {
        this.notificationService.markAllNotificationsAsRead()
            .pipe(take(1))
            .subscribe((): void => {
                this.notifications = [];
                this.newNotifications = 0;
            })
    }

    markNotificationAsRead(event: any, notification: Notification, noRedirect?: boolean): void {
        event.stopPropagation();
        this.notificationService.markNotificationAsRead(notification.id).pipe(take(1))
            .subscribe((): void => {
                this.notifications = this.notifications.filter(notif => notif.id !== notification.id);
                this.newNotifications -= 1;
                if (!noRedirect) {
                    this.notificationRedirect(notification);
                }
            });

    }

    viewAllNotifications(): void {
        const dialogRef: MatDialogRef<NotificationsListComponent> = this.dialog.open(NotificationsListComponent, {
            panelClass: ['mediumWindow'],
        });
    }

    private notificationRedirect(notification: Notification): void {
        this.notificationService.notificationRedirect(notification)
    }
}
